import React from 'react';
import {observer, inject} from 'mobx-react';
import classNames from 'classnames';
import HttpClient from "services/HttpClient";
const GET_MODULE = "/api/v1/modules/";
@inject('workshopDetails')
@inject('user')
@observer
export default class ShortWorkshopDetails extends React.Component {

  handleClick = () => {
    this.props.getModuleDescription(this.props.number - 1);

    if(this.props.workshopDetails.workshop.access_type !== 'not_purchased' &&
      this.props.workshopDetails.workshop.access_type !== 'pending'
    )
      this.props.workshopDetails.changeOpenedType({type: 'module', index: this.props.number - 1});
    else if(this.props.user.getUser() && this.props.user.getUser().role === 'admin')
      this.props.workshopDetails.changeOpenedType({type: 'module', index: this.props.number - 1});

  };

  render(){
    let active = false;

    if(this.props.workshopDetails.openedType.type === 'module' && this.props.workshopDetails.openedType.index === (this.props.number - 1) )
      active = true;

    return(<li className={classNames('workshop-card-module-item', {active: active })} onClick={this.handleClick}>
      <span className="workshop-card-module-number">{this.props.number}</span>
      <span className="workshop-card-module-caption">{this.props.title}</span>
    </li>)
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/ShortWorkshopDetails.jsx